'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/PostCodeCityStreetComponent.css');

var _EmailField = require('./EmailField');

var _EmailField2 = _interopRequireDefault(_EmailField);

var _Textfield = require('./Textfield');

var _Textfield2 = _interopRequireDefault(_Textfield);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
me={this} Id={"name"} ref={"name"} name="name"
IsRequired={true/false} Editable={true/false}  
Label={ Vas.Resources.Labels["Name"]} 
TitleMessageNotValidCharacter={Vas.Resources.Labels["Note"]} 
MessageNotValidCharacter={Vas.Resources.Labels["NotValidCharacter"]} 

optional:
Modus={"Name"} Tooltip={Vas.Resources.Tooltips["Name"]} OnChange={()=>{ this.setState({ Name:  $("#name").val() })}}
Autocomplete={false/true}=>"off"/"on"
*/
var EmailRepeatComponent = function (_Component) {
  _inherits(EmailRepeatComponent, _Component);

  function EmailRepeatComponent(props) {
    _classCallCheck(this, EmailRepeatComponent);

    var _this = _possibleConstructorReturn(this, (EmailRepeatComponent.__proto__ || Object.getPrototypeOf(EmailRepeatComponent)).call(this, props));

    _this.state = {};

    _this.emailInput = _react2.default.createRef();
    _this.emailRepeatInput = _react2.default.createRef();
    _this.icon = _react2.default.createRef();

    _this.required = _this.props.Required !== undefined && _this.props.Required !== null ? _this.props.Required : true;

    _this.Email = '';
    _this.EmailRepeat = '';

    _this.allFilled = _this.required === true ? false : true;
    _this.first = null;

    _this.state.EmailRepeat = false;
    _this.state.EmailValid = false;

    _this.state.IconId = _this.props.IconId;
    return _this;
  }

  _createClass(EmailRepeatComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'Update',
    value: function Update(observer) {
      var _this2 = this;

      this.setState({}, function () {
        if (observer === "EmailChecked") {
          _this2.setEditable();
        }
      });
    }
  }, {
    key: 'getAllFilled',
    value: function getAllFilled() {
      if (this.required === true) {
        var i = 0;
        this.first = null;

        if (document.getElementById('EmailRepeat').value.length > 0) {
          i++;
        } else {
          this.first = this.emailRepeatInput;
        }

        if (document.getElementById('Email').value.length > 0) {
          i++;
        } else {
          this.first = this.emailInput;
        }

        if (i === 2) {
          this.allFilled = true;
        }
      }
    }
  }, {
    key: 'setEditable',
    value: function setEditable() {
      if (this.emailInput.current.getValid() === true && this.emailInput.current.getExist() === false) {
        this.emailRepeatInput.current.setState({ editable: true });
      } else {
        this.emailRepeatInput.current.setState({ editable: false });
      }
    }
  }, {
    key: 'checkEmail',
    value: function checkEmail() {
      if ((0, _jquery2.default)('#Email').val().length > 0 && (0, _jquery2.default)('#EmailRepeat').val().length > 0) {
        if ((0, _jquery2.default)('#Email').val().toLowerCase() === (0, _jquery2.default)('#EmailRepeat').val().toLowerCase()) {
          var valid = false;
          if (this.emailInput.current.state.EmailValid === true && this.emailInput.current.state.EmailExist === false) {
            valid = true;
          }

          this.icon.current.setState({ Name: "Done", Color: "green" });

          this.setState({ EmailRepeat: true, EmailValid: valid });
          this.getAllFilled();
        } else {

          this.icon.current.setState({ Name: "Warning", Color: "red" });
          this.setState({ EmailRepeat: false, EmailValid: false });
          (0, _jquery2.default)('#EmailRepeat').val('');
          this.getAllFilled();
          _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
            AppURL: _Vas2.default.ApplicationUrl,
            Id: "MessageBox",
            Title: _Vas2.default.getText("Labels", "Order"),
            Message: _Vas2.default.getText("ErrorMessages", "EmailRepeatNotValid"),
            Field: "EmailRepeat" }), document.getElementById('messageContainer'));
        }
      } else {

        this.icon.current.setState({ Name: "Warning", Color: "red" });
        this.setState({ EmailRepeat: false });
        this.getAllFilled();
      }
    }
  }, {
    key: 'returnFilled',
    value: function returnFilled() {
      return [this.allFilled, this.first];
    }
  }, {
    key: 'returnFields',
    value: function returnFields() {
      return [this.emailInput, this.emailRepeatInput];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: "erc" },
        _react2.default.createElement(
          'div',
          { className: "Container" },
          _react2.default.createElement(
            'div',
            { className: "ContainerLeft" },
            _react2.default.createElement(_EmailField2.default, {
              AppURL: this.props.ApplicationUrl,
              me: this,
              Id: 'Email',
              ref: this.emailInput,
              Editable: true,
              IsRequired: this.required,
              Tooltip: _Vas2.default.getText("Tooltips", "Email"),
              Label: _Vas2.default.getText("Labels", "Email"),
              OnBlur: function OnBlur() {
                _this3.Email = (0, _jquery2.default)("#Email").val();_this3.setState({ EmailRepeat: false }, function () {
                  document.getElementById('EmailRepeat').value = '';
                  //this.icon.current.setState({ Name:"Warning",Color:"red" });
                  _this3.icon.current.setState({ Name: "" });
                  _this3.getAllFilled();
                });
              },
              ApiUrl: this.props.ApiUrl,
              ApiKey: this.props.ApiKey,
              Token: localStorage.getItem["vas_token"],
              AnonymousToken: localStorage.getItem["anonymous_token"],
              ErrorHandlingPage: function ErrorHandlingPage(error) {
                _this3.props.ErrorHandlingPage ? _this3.props.ErrorHandlingPage(error) : "";
              },
              Reference: this
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: "Container" },
          _react2.default.createElement(
            'div',
            { className: "ContainerLeftEmail" },
            _react2.default.createElement(_Textfield2.default, {
              me: this,
              Id: 'EmailRepeat',
              ref: this.emailRepeatInput,
              Editable: true,
              IsRequired: this.required,
              Tooltip: _Vas2.default.getText("Tooltips", "EmailRepeat"),
              Label: _Vas2.default.getText("Labels", "EmailRepeat"),
              OnBlur: function OnBlur() {
                _this3.checkEmail();
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: "IconEmailContainer" },
            _react2.default.createElement(_Icon2.default, {
              ref: this.icon,
              Name: "",
              Size: 24,
              Color: "red",
              Id: this.state.IconId
            })
          )
        )
      );
    }
  }]);

  return EmailRepeatComponent;
}(_react.Component);

exports.default = EmailRepeatComponent;